import { Injectable } from '@angular/core';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { Grant } from '@models';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class GrantService {
  public all$: Observable<Grant[]>;

  constructor(
    private readonly firestore: FirestoreService,
    private readonly tenantContext: TenantContextService,
  ) {
    this.all$ = this.tenantContext.tenantId$.pipe(
      switchMap(() =>
        this.firestore.listDocuments<Grant>(
          this.tenantContext.collections.ACCOUNTING_GRANTS,
        ),
      ),
      shareReplay(1),
    );
  }

  getById(id: string): Observable<Grant> {
    return this.firestore.getDocument<Grant>(
      this.tenantContext.collections.ACCOUNTING_GRANTS,
      id,
    );
  }

  async create(
    data: Omit<Grant, 'id' | 'createdAt' | 'updatedAt'>,
  ): Promise<string> {
    return this.firestore.create<Grant>(
      this.tenantContext.collections.ACCOUNTING_GRANTS,
      data,
    );
  }

  async update(data: Partial<Grant> & { id: string }): Promise<void> {
    return this.firestore.update<Grant>(
      this.tenantContext.collections.ACCOUNTING_GRANTS,
      data,
    );
  }

  async delete(id: string): Promise<void> {
    return this.firestore.delete(
      this.tenantContext.collections.ACCOUNTING_GRANTS,
      id,
    );
  }
}
